import { useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import { useMediaQuery, useTheme } from '@mui/system';

const iconStyles = {
    verticalAlign: 'middle',
    mr: '0.3rem',
}

const linkStyles = {
  color: '#fff',
  fontSize: {
    xs: '0.8rem',
    sm: '0.9rem',
    md: '1rem'
  },
  wordBreak: 'break-all'
}

const boxStyles = {
  display: 'flex', 
  flexDirection: 'column',
  alignItems: { xs: 'center', sm: 'flex-start' },
  ml: { 
    xs: 3, 
    md: '5rem'
  },
  pb: 2
}

const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box 
      component="footer" 
      sx={{
        minHeight: {
          xs: '9rem',
        },
        backgroundColor: 'var(--northwestern-purple)',
        display: 'flex',
        flexDirection: {
          xs: 'column',
          sm: 'row'
        },
        padding: 2,
        color: 'white',
      }}>
      <Box sx={{ display: {xs: 'flex', sm: 'block' }, justifyContent: { xs: 'center', sm: 'start' }, ml: {xs: 3}, mb: {xs: 2 }, wordBreak: 'break-word'}}>
        {isMobile ? (
          <>
            <Box component="img" alt="Northwestern Medicine logo" src="/images/NM_stacked.png" sx={{ width: '2rem', mr: 2 }} />
            <Typography variant="body2">© 2025 Northwestern Medicine</Typography>
          </>
        ) : (
          <>
            <Box component="img" alt="Northwestern University logo" src="/images/Vertical_white_RGB.png" sx={{ width: { sm:'10rem' }}}/>
            <Typography variant="body1">© 2025 Northwestern Medicine</Typography>
          </>
        )}
      </Box>
      <Box sx={boxStyles}>
        <Link sx={linkStyles} href="https://www.northwestern.edu/disclaimer.html" target="_blank" rel="noreferrer">{t('footer.disclaimer')}</Link>
        <Link sx={linkStyles} href="https://www.northwestern.edu/privacy/" target="_blank" rel="noreferrer">{t('footer.privacy')}</Link>
        <Link sx={linkStyles} href="https://www.northwestern.edu/accessibility/about/report-accessibility-issue.html" target="_blank" rel="noreferrer">{t('footer.accessibility')}</Link>
        <Link sx={linkStyles} href="https://policies.northwestern.edu/" target="_blank" rel="noreferrer">{t('footer.policy')}</Link>
      </Box>
      <Box sx={boxStyles}>
        <Typography variant="subtitle1" sx={{margin: 0, paddingBottom: '0.5rem', fontWeight: 600}}>{t('contact.title')}:</Typography>
        <Link sx={linkStyles} href={`mailto:${t('contact.email')}`}> 
            <EmailIcon sx={iconStyles} /> 
            {t('contact.email')}
        </Link>
        <Link sx={linkStyles} href={`tel:${t('contact.phone')}`}>
            <LocalPhoneIcon sx={iconStyles} /> 
            {t('contact.phone')}
        </Link>
      </Box>
    </Box>
  )
}

export default Footer;